<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <ClientsTable :clients="loans"/>
        </div>
      </div>
      
    </div>
</template>
  
<script>
import axios from "axios";
import ClientsTable from "./components/Table.vue";  
export default {
    name: "tables",
    components: {
        ClientsTable,
    },
    data() {
        return {
            clients:[],
            loans:[],
        };
    },
    methods:{
        async fethClients(config){
            let self=this;
            axios.get(this.$store.state.apiURL+'list/clients?recperpage=all',config)
            .then((result)=>{
                console.log(result);
                this.clients=result.data.clients;
                this.fetchLoans(config);
                
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        async fetchLoans(config){
            let self=this;
            axios.get(this.$store.state.apiURL+'list/loans?recperpage=all&order=id&sort=desc',config)
            .then((result)=>{
                console.log(result);
                this.loans=result.data.loans;
                // Asegúrate de que los clientes ya han sido cargados
                if (this.clients && this.clients.length > 0) {
                    // Crea un mapa de clientes para acceder fácilmente a sus datos
                    const clientsMap = this.clients.reduce((map, client) => {
                        map[client.id] = { name: client.name, document: client.document };
                        return map;
                    }, {});
                    // Mapea los préstamos y agrega la información del cliente
                    this.loans = this.loans.map(loan => {
                        const clientInfo = clientsMap[loan.client_id] || {};
                        return {
                            ...loan,
                            name: clientInfo.name || null,
                            document: clientInfo.document || null
                        };
                    });
                }
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        calcAge(data){
            let d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;
            d=[year, month, day].join('-')
            /*------------*/
            let nowDate = new Date(d);//fecha del sistema con el mismo formato que "fechaUsuario"
            let birthDate = new Date(data);
            //alert(birthDate+" "+nowDate);
            //Calculamos años
            let age = nowDate.getFullYear() - birthDate.getFullYear();
            let m = nowDate.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && nowDate.getDate() < birthDate.getDate())) {
                age--;
            }
            // calculamos los months
            let months=0;
            if(nowDate.getMonth()>birthDate.getMonth()){
                months=nowDate.getMonth()-birthDate.getMonth();
            }else if(nowDate.getMonth()<birthDate.getMonth()){
                months=12-(birthDate.getMonth()-nowDate.getMonth());
            }else if(nowDate.getMonth()==birthDate.getMonth() && nowDate.getDate()>birthDate.getDate() ){
                if(nowDate.getMonth()-birthDate.getMonth()==0){
                    months=0;
                }else{
                    months=11;
                }
                
            }
            // Obtener días: día actual - día de cumpleaños
            let days  = nowDate.getDate() - birthDate.getDate();
            if(days < 0) {
                // Si días es negativo, día actual es mayor al de cumpleaños,
                // hay que restar 1 mes, si resulta menor que cero, poner en 11
                months = (months - 1 < 0) ? 11 : months - 1;
                // Y obtener días faltantes
                days = 30 + days;
            }
            return(age+' años, '+months+' meses, '+ days+' días');
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fethClients(config);
    },
};
</script>
  